// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3fcUZ","itemTitle":"ClientEmergencyInfo_itemTitle__21urp","itemText":"ClientEmergencyInfo_itemText__1HkdK"};